/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddDashboardWidgetRequestBody,
  AddDashboardWidgetRequestBody$Outbound,
  AddDashboardWidgetRequestBody$outboundSchema,
} from "../components/adddashboardwidgetrequestbody.js";

export type AddDashboardWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AddDashboardWidgetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  addDashboardWidgetRequestBody: AddDashboardWidgetRequestBody;
};

/** @internal */
export type AddDashboardWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AddDashboardWidgetSecurity$outboundSchema: z.ZodMiniType<
  AddDashboardWidgetSecurity$Outbound,
  AddDashboardWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function addDashboardWidgetSecurityToJSON(
  addDashboardWidgetSecurity: AddDashboardWidgetSecurity,
): string {
  return JSON.stringify(
    AddDashboardWidgetSecurity$outboundSchema.parse(addDashboardWidgetSecurity),
  );
}

/** @internal */
export type AddDashboardWidgetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AddDashboardWidgetRequestBody: AddDashboardWidgetRequestBody$Outbound;
};

/** @internal */
export const AddDashboardWidgetRequest$outboundSchema: z.ZodMiniType<
  AddDashboardWidgetRequest$Outbound,
  AddDashboardWidgetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    addDashboardWidgetRequestBody: AddDashboardWidgetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      addDashboardWidgetRequestBody: "AddDashboardWidgetRequestBody",
    });
  }),
);

export function addDashboardWidgetRequestToJSON(
  addDashboardWidgetRequest: AddDashboardWidgetRequest,
): string {
  return JSON.stringify(
    AddDashboardWidgetRequest$outboundSchema.parse(addDashboardWidgetRequest),
  );
}
